module.exports = __webpack_public_path__ + "static/media/location.baf996b0.svg";